define('compositeView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'containerView',
  'template!compositeView'
], function (
    App,
    Module,
    Backbone,
    _,
    ContainerView,
    Tpl
) {
  'use strict';

  Module.exports = ContainerView.extend({
    template: Tpl,
    className: 'composite-view',
    childView: null,

    regions: _.extend({}, ContainerView.prototype.regions, {
      collectionRegion: '.collection-region'
    }),

    initialize: function () {
      if(!this.collection)
        this.collection = new Backbone.Collection();

      var View = Backbone.Marionette.CollectionView.extend({
        childView: this.getChildView(),
        className: 'composite-collection-view'
      });
      this.collectionView = new View({
        collection: this.collection
      });
      this.collectionView.childViewOptions = this.childViewOptions();
    },      

    onRender: function () {   
      this.getRegion('collectionRegion').show(this.collectionView);    
    },

    scrollBottom: function () {
      if(!this.collectionView)
        return;

      var scrollHeight = this.collectionView.el.scrollHeight;
      this.collectionView.$el.scrollTop(scrollHeight - this.collectionView.$el.height());
    }
  });
});
